import React, { useState, useEffect } from 'react';
import InputLabel from '../../../sharecomponents/InputLabel';
import CloseButton from '../../../sharecomponents/CloseButton';
import { activeDialog } from '../../../../utils/Common';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import Post from '../../../../utils/Post copy';

const EditarUsuario = (p) => {
    const close = p.close ?? (() => { });
    const [data, setdata] = useState({ ...(p.data ?? {}), passsword: "" });
    const ranchos = p.ranchos ?? [];
    const areas = p.areas ?? [];
    const [dialog, setdialog] = useState({ show: false });
    const [loader, setloader] = useState(false);
    const ldr = (<div className='w-100 h-100 top-left-front bg-white3 blur-s'><div className='loader-local' /></div>);

    useEffect(() => {
        const dt = { ...(p.data ?? {}), passsword: "", ranchosHash: {}, areasHash: {} };
        if (p.data) {
            p.data.ranchos.forEach(r => dt.ranchosHash[r.id] = r);
            p.data.areas.forEach(a => dt.areasHash[a.id] = a);
        }
        setdata({ ...dt });
    }, [p.data])

    const change = (e) => {
        setdata({ ...data, [e.target.name]: e.target.value });
    }

    const ajustarHash = (tipo, valor) => {
        const id = valor.id;
        const dtCopy = { ...data };
        if (dtCopy[tipo][id]) {
            delete dtCopy[tipo][id];
        } else {
            dtCopy[tipo][id] = valor;
        }
        setdata(dtCopy);
    }

    const actualizar = async () => {
        if (data.nombre == "") {
            activeDialog(setdialog, "El nombre no puede estar vacio", "Error", "error");
            return;
        }

        if (data.password && data.password !== "" && data.password.length < 6) {
            activeDialog(setdialog, "Las contraseñas deben tener un minimo de 6 caraceres", "error", "Error");
            return;
        }
        const dtCopy = { ...data };
        dtCopy.ranchos = Object.keys(dtCopy.ranchosHash).map(k => +k);
        dtCopy.areas = Object.keys(dtCopy.areasHash).map(k => +k);
        let resp = await Post('secure/users/update', dtCopy, setloader);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Error');
            return;
        }
        close(true);
    }

    /**
     * Cambia el estado de la cuenta de usuario entre activo o inactivo
     */
    const switchUser = async () => {
        let resp = await Post('secure/users/switch', { id: data.id }, setloader);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Error');
            return;
        }
        close(true);
    }
    console.log(data)
    return (
        <>
            <div className='w-100 h-100 blur-s bg-black4 p-2 contenedor round-s overflow' style={{ position: "fixed", top: 0, left: 0, zIndex: 10 }}>
                <CloseButton close={() => close(false)} floatElement={true} />
                <div className='row justify-content-evenly w-100 m-0 p-0'>
                    <div className='col-lg-12 mt-5 mb-5'></div>
                    <div className='col-lg-12 mt-5 mb-5 p-5'></div>
                    <div className='bw-500 shadow-multi round-s bg-white p-2'>
                        <div className='row justify-content-evenly w-100 m-0 p-0'>
                            <div className='w-100 text-center text-l text-bold'>Editar usuario</div>
                            <InputLabel label='Nombre' name='nombre' value={data.nombre} change={change} />

                            <div className='form-group bw-500 mt-2 mb-2 pb-3'>
                                <label className='text-bold ps-2'>Ranchos</label>
                                <div className='row justify-content-between w-100 m-0 p-0'>
                                    {ranchos.map((rancho, i) => <div key={rancho.nombre + i} className='form-check form-switch bw-200 border rounded '>
                                        <input className='form-check-input' type='checkbox' role='switch' id={rancho.nombre + i} checked={data.ranchosHash?.[rancho.id] ? true : false} onChange={() => ajustarHash('ranchosHash', rancho)} />
                                        <label className='form-check-label' htmlFor={rancho.nombre + i}>{rancho.nombre}</label>
                                    </div>)}
                                </div>
                            </div>

                            <div className='form-group bw-500 mt-2 mb-2 pb-3'>
                                <label className='text-bold ps-2'>Áreas</label>
                                <div className='row justify-content-between w-100 m-0 p-0'>
                                    {areas.map((area, i) => <div key={area.nombre + i} className='form-check form-switch bw-200 border rounded '>
                                        <input className='form-check-input' type='checkbox' role='switch' id={area.nombre + i} checked={data.areasHash?.[area.id] ? true : false} onChange={() => ajustarHash('areasHash', area)} />
                                        <label className='form-check-label' htmlFor={area.nombre + i}>{area.nombre}</label>
                                    </div>)}
                                </div>
                            </div>

                            {/*<div className='form-group bw-500 mt-2 mb-2'>
                                <label className='text-bold ps-2'>Rancho</label>
                                <select className='form-control shadow-sm round-m' name='rancho_id' onChange={change} value={data.rancho_id}>
                                    <option value='' >Sin rancho</option>
                                    {ranchos.map((rancho, i) => <option key={rancho.nombre + i} value={rancho.id} className='round-xxl mb-2' >{rancho.nombre}</option>)}
                                </select>
                            </div>
                            <div className='form-group bw-500 mt-2 mb-2'>
                                <label className='text-bold ps-2'>Área</label>
                                <select className='form-control shadow-sm round-m' name='area_id' onChange={change} value={data.area_id}>
                                    <option value='' >Sin área</option>
                                    {areas.map((area, i) => <option key={area.nombre + i} value={area.id} className='round-xxl mb-2' >{area.nombre}</option>)}
                                </select>
                            </div>*/}
                            <InputLabel label='Nueva contraseña (deje en blanco para mantener la actual)' name='password' type='password' value={data.password} change={change} />
                            <div className='w-100 text-center'>
                                <button className='btn btn-warning round-xxl mt-3 mb-4 shadow bw-400 text-bold' onClick={actualizar}>Actualizar</button>
                            </div>

                            <div className='w-100 text-center mt-4'>
                                <div className='w-100 text-center text-s'>Deshabilitar la cuenta de usuario le bloqueará a esté el acceso al sistema incluso si se cuenta con la contraseña correcta</div>
                                <button className={`btn text-bold btn-${data.estatus ? 'danger bg-red3' : 'light border border-success border-2'} round-xxl btn-sm shadow`} onClick={switchUser} >{data.estatus ? 'Deshabilitar cuenta' : 'Restaurar usuario'}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <VainillaDialog data={dialog} />
            {loader && ldr}
        </>

    )
}

export default EditarUsuario;